/* eslint-disable max-len */
import React, { Component } from 'react';
import moment from 'moment';
import Rebate from '../rebate';
import gaPush from '../../../../../../globs/utils/google-analytics';
import FormattedNumberCustom from '../../../../../../util/formatted-number-custom/';

class PerformanceDetail extends Component {
  state = {
    selectedMonthKey: null,
  }

  handleMonthBlockClick = (orderKey) => {
    // console.log('orderKey<>?', orderKey);
    gaPush('event', {
      category: 'TonageReport',
      action: 'DetailsMonthClicked',
      label: orderKey,
    });
    if (this.state.selectedMonthKey === orderKey) {
      this.setState({
        selectedMonthKey: null,
      });
    } else {
      this.setState({
        selectedMonthKey: orderKey,
      });
    }
  }

  sendMonthData = (key) => {
    const { props } = this;
    props.fetchFilterData(key);
  }

  quantityFormat = (quantity) => {
    // console.log('quantity-->', quantity);
    const addProductQtyIn = 'Ton';
    const roundedQty = addProductQtyIn === 'Ton' ? quantity : Math.round(quantity * 20);
    return (
      // <div>
      //   {roundedQty} {
      //     addProductQtyIn === 'Ton' ?
      //       'Ton' : 'Bags'
      //   }
      // </div>
      <div>
        <FormattedNumberCustom value={roundedQty} /> {
                                                                                      addProductQtyIn === 'Ton' ?
                                                                                          'Ton' : 'Bags'
                                                                                    }
      </div>
    );
  }

  renderMonthlyOrders = (orders) => {
    const sites = orders.sites || {};
    // console.log('sites====>', sites);
    const openOrders = orders.open_orders;
    const allOrders = {};
    Object.keys(sites).forEach(site => {
      // console.log('sites ==>', sites[site]);
      // console.log('ship_to_sap_number main ==>', [sites[site].ship_to_sap_number], sites[site].quantity_type);
      if (sites[site].quantity_type === 'openTonnageType') {
        // console.log('ship_to_sap_number if ==>', [sites[site].ship_to_sap_number]);
        if ('openTonnageType' in allOrders) {
          allOrders['openTonnageType'] = {
            ...allOrders['openTonnageType'],
            [sites[site].ship_to_sap_number]: sites[site],
            // }
          }
        } else {
          // console.log('ship_to_sap_number else ==>', [sites[site].ship_to_sap_number]);
          allOrders['openTonnageType'] = { [sites[site].ship_to_sap_number]:  sites[site] };
        }
      }
      if (sites[site].quantity_type === 'closeTonnageType') {
        if ('closeTonnageType' in allOrders) {
          allOrders['closeTonnageType'] = {
            ...allOrders['closeTonnageType'],
            [sites[site].ship_to_sap_number]: sites[site],
          }
        } else {
          allOrders['closeTonnageType'] = { [sites[site].ship_to_sap_number]:  sites[site] };
        }
      }
    })
    // const operOrderQty = Object.keys(sites).filter((site) => sites[site.quantity_type] === 'openTonnageType');
    // const closedOrderQty = Object.keys(sites).filter((site) => sites[site.quantity_type] === 'allOrders');
    // console.log("allOrders===>", allOrders);
    const openOrdersMat = orders.open_orders && orders.open_orders.material;
    return (
      <div>
        <div className="lr-performance-point-open lr-performance-border-bottom">
          {
            openOrders &&
            <div className="lr-performance-border-bottom" key={1}>
              <div className="lr-performance-heading-row">
                <div className="lr-performance-heading-row-colL"><div className="order-type">Open Orders</div></div>
                <div className="lr-performance-heading-row-colR"><div className="site-total-qty"> {this.quantityFormat(openOrders.total_material_quantity)} </div></div>
              </div>
              {
                openOrdersMat &&
                Object.keys(openOrdersMat).map((material) => {
                  const materialInfo = openOrdersMat[material];
                  return (
                    <div className="lr-performance-dealer-Container" key={material.code}>
                      <div className="lr-performance-point-inner-repeat" key={materialInfo.code}>
                        <div className="lr-performance-bag-image">
                          <img src={materialInfo.image} />
                        </div>
                        <div className="lr-performance-point-open-data-left">
                          <p className="lr-performance-purchase-date">
                            {materialInfo.name}
                          </p>
                        </div>
                        <div className="lr-performance-point-open-data-right">
                          <div className="site-product-qty"> {this.quantityFormat(materialInfo.quantity)} </div>
                        </div>
                      </div>
                    </div>
                  );
                })
              }
            </div>
          }
        </div>
        <div className="lr-performance-point-open lr-performance-border-bottom">
          { 'openTonnageType' in allOrders && <div className="order-type">Open Orders</div> }
          {
            allOrders &&
            Object.keys(allOrders['openTonnageType'] || {}).map((site) => {
              const siteName = allOrders['openTonnageType'][site].name;
              const quantity = allOrders['openTonnageType'][site].total_quantity;
              // console.log('allOrders['openTonnageType']===>', allOrders['openTonnageType']);
              return (
                <div className="lr-performance-border-bottom" key={site}>
                  <div className="lr-performance-heading-row">
                    <div className="lr-performance-heading-row-colL"><p className="lr-performance-point-open-heading">{siteName}</p></div>
                    <div className="lr-performance-heading-row-colR"><div className="site-total-qty"> {this.quantityFormat(quantity)} </div></div>
                  </div>
                  {
                    Object.keys(allOrders['openTonnageType'][site].material).map((material) => {
                      const materialInfo = allOrders['openTonnageType'][site].material;
                      return (
                        <div className="lr-performance-dealer-Container" key={material}>
                          <div className="lr-performance-point-inner-repeat" key={materialInfo[material].code}>
                            <div className="lr-performance-bag-image">
                              <img src={materialInfo[material].image} />
                            </div>
                            <div className="lr-performance-point-open-data-left">
                              <p className="lr-performance-purchase-date">
                                {materialInfo[material].name}
                              </p>
                            </div>
                            <div className="lr-performance-point-open-data-right">
                              <div className="site-product-qty"> {this.quantityFormat(materialInfo[material].quantity)} </div>
                            </div>
                          </div>
                        </div>
                      );
                    })
                  }
                </div>
              );
            })
          }
          { 'closeTonnageType' in allOrders && <div className="order-type">Closed orders</div> }
          {
            allOrders &&
            Object.keys(allOrders['closeTonnageType'] || {}).map((site) => {
              const siteName = allOrders['closeTonnageType'][site].name;
              const quantity = allOrders['closeTonnageType'][site].total_quantity;
              // console.log('allOrders['closeTonnageType']===>', allOrders['closeTonnageType']);
              return (
                <div className="lr-performance-border-bottom" key={site}>
                  <div className="lr-performance-heading-row">
                    <div className="lr-performance-heading-row-colL"><p className="lr-performance-point-open-heading">{siteName}</p></div>
                    <div className="lr-performance-heading-row-colR"><div className="site-total-qty"> {this.quantityFormat(quantity)} </div></div>
                  </div>
                  {
                    Object.keys(allOrders['closeTonnageType'][site].material).map((material) => {
                      const materialInfo = allOrders['closeTonnageType'][site].material;
                      return (
                        <div className="lr-performance-dealer-Container" key={material}>
                          <div className="lr-performance-point-inner-repeat" key={materialInfo[material].code}>
                            <div className="lr-performance-bag-image">
                              <img src={materialInfo[material].image} />
                            </div>
                            <div className="lr-performance-point-open-data-left">
                              <p className="lr-performance-purchase-date">
                                {materialInfo[material].name}
                              </p>
                            </div>
                            <div className="lr-performance-point-open-data-right">
                              <div className="site-product-qty"> {this.quantityFormat(materialInfo[material].quantity)} </div>
                            </div>
                          </div>
                        </div>
                      );
                    })
                  }
                </div>
              );
            })
          }
          {
            sites && Object.keys(allOrders).length === 0 &&
            Object.keys(sites).map((site) => {
              const siteName = sites[site].name;
              const quantity = sites[site].total_quantity;
              return (
                <div className="lr-performance-border-bottom" key={site}>
                  <div className="lr-performance-heading-row">
                    <div className="lr-performance-heading-row-colL"><p className="lr-performance-point-open-heading">{siteName}</p></div>
                    <div className="lr-performance-heading-row-colR"><div className="site-total-qty"> {this.quantityFormat(quantity)} </div></div>
                  </div>
                  {
                    Object.keys(sites[site].material).map((material) => {
                      const materialInfo = sites[site].material;
                      return (
                        <div className="lr-performance-dealer-Container" key={material}>
                          <div className="lr-performance-point-inner-repeat" key={materialInfo[material].code}>
                            <div className="lr-performance-bag-image">
                              <img src={materialInfo[material].image} />
                            </div>
                            <div className="lr-performance-point-open-data-left">
                              <p className="lr-performance-purchase-date">
                                {materialInfo[material].name}
                              </p>
                            </div>
                            <div className="lr-performance-point-open-data-right">
                              <div className="site-product-qty"> {this.quantityFormat(materialInfo[material].quantity)} </div>
                            </div>
                          </div>
                        </div>
                      );
                    })
                  }
                </div>
              );
            })
          }
        </div>
      </div>
    );
  }

  render() {
    const { props, state } = this;
    const { orders } = props;
    const orderObjLen = Object.keys(orders).length;
    const currMnthKey = Object.keys(orders).filter(mnthKey => Number(mnthKey.slice(5, 7)) === (new Date().getMonth() + 1))[0];
    const currMonthOrder = orders[currMnthKey];
    return (
      <div className="lr-performance-detail">
        {
          !props.enabledQuarters &&
          <Rebate order={currMonthOrder} user={props.user} />
        }
        {orderObjLen > 0 &&
          <div className="lr-performance-heading">Tonnage Details</div>
        }
        <div className="lr-performance-detail_data">
          {
            Object.keys(orders).filter((mnthKey) => {
              if (!props.enabledQuarters) return mnthKey.slice(5, 7) <= (new Date().getMonth() + 1);
              return true;
            }).sort().reverse()
            .map(monthKey => (
              <div
                className={`lr-performance-detail_data_repeat ${state.selectedMonthKey === monthKey ? 'lr-active' : ''}`}
                key={Math.random()}
                onClick={() => { this.sendMonthData(monthKey); }}
              >
                <div className="lr-performance-detail_data_container">
                  <div className="font-icon-arrows-up-down">
                    <i className="icon-arrow_down" />
                    <i className="icon-arrow_up" />
                  </div>
                  <div
                    className="lr-performance-point lr-performance-border-bottom lr-accord-head"
                    onClick={() => this.handleMonthBlockClick(monthKey)}
                  >
                    <p className="lr-performance-point-month">
                      {moment(`${monthKey}`, 'YYYY-MM').format('MMMM YYYY').toUpperCase()}
                    </p>
                    <div className="lr-performance-point-count">
                      {this.quantityFormat(orders[monthKey].total_quantity)}
                    </div>
                  </div>
                  {
                    this.renderMonthlyOrders(orders[monthKey])
                  }
                </div>
              </div>
            ))
          }
        </div>
      </div>
    );
  }
}
PerformanceDetail.propTypes = {
};

PerformanceDetail.defaultProps = {
  user: undefined,
};
export default PerformanceDetail;
